import { ChartConfig, FilterType } from '../types';

export const CHART_CONFIG: ChartConfig = {
  height: 400,
  margin: {
    right: 0,
    left: 16,
    top: 8,
    bottom: 32, // Optimized bottom margin for single-line x-axis labels with time and date
  },
  paddingPercentage: 0.1, // 20% padding for Y-axis
};

export const DEFAULT_FILTER: FilterType = 'all';

export const GRADIENT_ID = 'balance';

export const GRADIENT_COLORS = {
  START: 'rgba(170, 178, 255, 0.8)',
  MIDDLE: 'rgba(170, 178, 255, 0.3)',
  END: 'rgba(170, 178, 255, 0)',
} as const;

export const GRADIENT_STOPS = {
  START: '0%',
  MIDDLE: '76.44%',
  END: '100%',
} as const;

export const FILTER_DATA_LIMITS: Record<FilterType, number | null> = {
  weekly: 1,
  monthly: 2,
  yearly: null, // Show all data
  all: null, // Show all data
} as const;
